import { Grid, Stack, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import Banner from 'common/components/Banner/Banner';
import Breadcrumbs from 'common/components/Breadcrumbs/Breadcrumbs';
import StepperProgressBar from 'common/components/StepperProgressBar/StepperProgressBar';
import { aiProgressBarElements } from 'common/constants/AISimulationConstants';
import { toSentenceCase, urlWithTenant } from 'common/utils/utilFunctions';

import { IStepHeaderProps } from 'features/AiSimulation/api/type-def';

import styles from './StepHeader.module.scss';

const { imageColor } = styles;
const StepHeader = (props: IStepHeaderProps) => {
	const { title, currentStepIndex = -1, showStepbar = false, Icon } = props;

	const breadcrumb = [
		<Link key="simulation-arena-link" to={urlWithTenant('/simulation-arena')}>
			{toSentenceCase('Simulation Arena')}
		</Link>,
		<Typography key="simulation-step">{toSentenceCase(title)}</Typography>,
	];

	const stepVal = aiProgressBarElements[currentStepIndex];

	return (
		<Stack sx={{ mb: 4 }}>
			<Breadcrumbs
				breadcrumbs={breadcrumb}
				className={styles['step-header-bread-crumbs']}
				customClass
			/>
			<Grid className={styles['step-header-container']}>
				<Banner>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						className={styles['header-title']}
					>
						{Icon && (
							<Icon className={styles['header-icon']} fill={imageColor} />
						)}
						{toSentenceCase(title)}
					</Grid>
				</Banner>
			</Grid>
			{showStepbar && (
				<StepperProgressBar
					disabled
					value={stepVal?.value}
					valueLabelDisplay="off"
					status={stepVal?.label}
					progressBarElements={aiProgressBarElements}
					className={styles['progress-bar']}
				/>
			)}
		</Stack>
	);
};

export default StepHeader;
